import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableRow,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
} from "@material-ui/core";
import PageTitle from "../../components/PageTitle/PageTitle";
import IconMasterService from "./Locality/Service/iconMasterService";
import CalenderAssignmentService from "./Locality/Service/calenderAssignmentService";
import * as Yup from 'yup';
import TablePagination from "@material-ui/core/TablePagination";
import { Grid, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
// import PageTitle from "../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from "@material-ui/core/styles";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#0f3b62ad",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflowX: "auto",
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  imagePreview: {
    maxWidth: '200px',
    maxHeight: '200px',
    marginTop: theme.spacing(2),
    borderRadius: '4px',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
}));

export default function IconMaster() {
  const tableHeaders = ['Icon Name', 'Image', 'Status', 'Edit', 'Delete'];
  const classes = useStyles();
  const [iconMasterList, setIconMasterList] = useState([]);
  const [pg, setPg] = useState(0);
  const [rpg, setRpg] = useState(10);
  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [error, setError] = useState(null);
  const [images, setImages] = useState([]);
  const [imageUrl, setImageUrl] = useState('');
  const [previousImageUrl, setPreviousImageUrl] = useState('');
  const [uploading, setUploading] = useState(false);

  const deleteAzureBlob = (url) => {
    if (!url || url.startsWith("data:")) return Promise.resolve();
    return CalenderAssignmentService.deleteAzureImage({ imageURL: url }).catch(() => {});
  };

  const [iconMaster, setIconMaster] = useState({
    iconName: '',
    imageUrl: '',
    status: 'active',
  });

  const validationSchema = Yup.object().shape({
    iconName: Yup.string().required('Icon Name is required'),
    status: Yup.string().oneOf(['active', 'inactive'], 'Status must be active or inactive'),
  });

  const formik = useFormik({
    initialValues: iconMaster,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      if (isEditMode) {
        updateIconMaster();
      } else {
        addIconMaster();
      }
    },
  });

  useEffect(() => {
    getIconMasterList();
    return () => {
      setIconMasterList([]);
    };
  }, []);

  const getIconMasterList = () => {
    const body = {};
    
    IconMasterService.findIconMasterList(body)
      .then((res) => {
        const list = Array.isArray(res) ? res : [];
        setIconMasterList(
          list.map((row) => ({
            ...row,
            imageUrl: row.imageUrl,
          })),
        );
      })
      .catch((err) => {
        console.error("Error fetching icon master list:", err);
        setError(err.message);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPg(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRpg(parseInt(event.target.value, 10));
    setPg(0);
  };

  const handleOpen = (status) => {
    if (status) {
      const resetData = {
        iconName: '',
        imageUrl: '',
        status: 'active',
      };
      setIconMaster(resetData);
      setImageUrl('');
      setPreviousImageUrl('');
      setImages([]);
      setIsEditMode(false);
      formik.resetForm({
        values: resetData
      });
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setIsEditMode(false);
    setImageUrl('');
    setPreviousImageUrl('');
    setImages([]);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
    
    // Create preview URL for the first image
    if (files.length > 0) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUrl(reader.result);
      };
      reader.readAsDataURL(files[0]);
    }
  };

  const handleUpload = async () => {
    if (images.length === 0) {
      alert("Please select an image first.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    const image = images[0];
    formData.append('image', image);
    formData.append('imageName', image.name);

    try {
      const res = await CalenderAssignmentService.uploadImage(formData);
      const newUrl = res?.url || "";
      if (!newUrl) throw new Error("Upload succeeded but no image URL returned.");
      if (previousImageUrl && previousImageUrl !== newUrl) {
        await deleteAzureBlob(previousImageUrl);
      }
      setImageUrl(newUrl);
      setPreviousImageUrl(newUrl);
      alert("Image uploaded successfully!");
      setUploading(false);
    } catch (err) {
      console.error("Error uploading image:", err);
      alert(err.response?.data?.message || "Error uploading image");
      setUploading(false);
    }
  };

  const addIconMaster = async () => {
    try {
      const resolvedUrl = imageUrl || formik.values.imageUrl;
      if (!resolvedUrl || resolvedUrl.startsWith("data:")) {
        alert("Please upload an image to Azure before saving.");
        return;
      }
      const body = {
        iconName: formik.values.iconName,
        imageUrl: resolvedUrl,
        status: formik.values.status,
      };

      await IconMasterService.createIconMaster(body);
      alert("Icon Master added successfully!");
      handleClose();
      setTimeout(() => {
        getIconMasterList();
      }, 100);
    } catch (err) {
      console.error("Error adding icon master:", err);
      alert(err.response?.data?.message || "Error adding icon master");
    }
  };

  const editIconMaster = (iconMasterData) => {
    const obj = {
      _id: iconMasterData._id,
      iconName: iconMasterData.iconName || '',
      imageUrl: iconMasterData.imageUrl || '',
      status: iconMasterData.status || 'active',
    };

    setIconMaster(obj);
    setImageUrl(obj.imageUrl || "");
    setPreviousImageUrl(obj.imageUrl || "");
    setImages([]);
    setIsEditMode(true);
    setOpen(true);
  };

  const updateIconMaster = async () => {
    try {
      const resolvedUrl = imageUrl || formik.values.imageUrl;
      if (!resolvedUrl || resolvedUrl.startsWith("data:")) {
        alert("Please upload an image to Azure before saving.");
        return;
      }
      const body = {
        iconName: formik.values.iconName,
        imageUrl: resolvedUrl,
        status: formik.values.status,
      };

      await IconMasterService.updateIconMaster(iconMaster._id, body);
      if (previousImageUrl && previousImageUrl !== resolvedUrl) {
        await deleteAzureBlob(previousImageUrl);
      }
      alert("Icon Master updated successfully!");
      handleClose();
      setTimeout(() => {
        getIconMasterList();
      }, 100);
    } catch (err) {
      console.error("Error updating icon master:", err);
      alert(err.response?.data?.message || "Error updating icon master");
    }
  };

  const deleteIconMaster = (iconMasterDelete) => {
    if (!iconMasterDelete) {
      return;
    }

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Icon Master record?"
    );
    
    if (!confirmDelete) {
      return;
    }

    IconMasterService.deleteIconMaster(iconMasterDelete._id)
      .then((res) => {
        alert("Icon Master deleted successfully!");
        getIconMasterList();
      })
      .catch((err) => {
        console.error("Error deleting icon master:", err);
        alert(err.response?.data?.message || "Error deleting icon master");
      });
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <PageTitle title="Icon Master" />
        </Grid>
        <Grid item xs={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleOpen(true)}
            style={{ marginTop: '10px' }}
          >
            Add Icon Master
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget
            title="Icon Master List"
            upperTitle
            noBodyPadding
            bodyClass={classes.tableOverflow}
          >
            <TableContainer component={Paper} style={{ maxHeight: 500 }}>
              <Table stickyHeader className="mb-0">
                <TableHead>
                  <TableRow>
                    {tableHeaders.map((header) => (
                      <StyledTableCell key={header}>{header}</StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {iconMasterList
                    .slice(pg * rpg, pg * rpg + rpg)
                    .map((iconMasterItem) => (
                      <TableRow key={iconMasterItem._id}>
                        <TableCell className="pl-3 fw-normal">
                          {iconMasterItem.iconName || 'N/A'}
                        </TableCell>
                        <TableCell className="pl-3 fw-normal">
                          {iconMasterItem.imageUrl ? (
                            <img 
                              src={iconMasterItem.imageUrl} 
                              alt={iconMasterItem.iconName}
                              style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
                            />
                          ) : (
                            'No Image'
                          )}
                        </TableCell>
                        <TableCell className="pl-3 fw-normal">
                          <span style={{ 
                            padding: '4px 8px', 
                            borderRadius: '4px',
                            backgroundColor: iconMasterItem.status === 'active' ? '#4caf50' : '#f44336',
                            color: 'white',
                            fontSize: '12px',
                            textTransform: 'capitalize'
                          }}>
                            {iconMasterItem.status || 'active'}
                          </span>
                        </TableCell>
                        <TableCell className="pl-3 fw-normal">
                          <IconButton
                            color="primary"
                            onClick={() => editIconMaster(iconMasterItem)}
                            aria-label="edit"
                          >
                            <EditIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell className="pl-3 fw-normal">
                          <IconButton
                            color="secondary"
                            onClick={() => deleteIconMaster(iconMasterItem)}
                            aria-label="delete"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              count={iconMasterList.length}
              page={pg}
              onPageChange={handleChangePage}
              rowsPerPage={rpg}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Widget>
        </Grid>
      </Grid>

      {/* Add/Edit Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        scroll="paper"
        
        PaperProps={{
          style: {
            maxHeight: '90vh',
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle id="form-dialog-title">
          {isEditMode ? "Edit Icon Master" : "Add Icon Master"}
        </DialogTitle>
        <form onSubmit={formik.handleSubmit}>
          <DialogContent
            style={{
              overflowY: 'auto',
              maxHeight: 'calc(90vh - 150px)',
              padding: '20px 24px'
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  autoFocus
                  margin="normal"
                  id="iconName"
                  name="iconName"
                  label="Icon Name"
                  type="text"
                  variant="outlined"
                  value={formik.values.iconName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.iconName && Boolean(formik.errors.iconName)}
                  helperText={formik.touched.iconName && formik.errors.iconName}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <Box className={classes.imageContainer}>
                  <input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="image-upload"
                    type="file"
                    onChange={handleFileChange}
                  />
                  <label htmlFor="image-upload">
                    <Button
                      variant="outlined"
                      component="span"
                      disabled={uploading}
                    >
                      {uploading ? 'Uploading...' : 'Select Image'}
                    </Button>
                  </label>
                  {images.length > 0 && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleUpload}
                      disabled={uploading}
                      style={{ marginTop: '10px' }}
                    >
                      {uploading ? 'Uploading...' : 'Upload Image'}
                    </Button>
                  )}
                  {(imageUrl || formik.values.imageUrl) && (
                    <img
                      src={imageUrl || formik.values.imageUrl}
                      alt="Preview"
                      className={classes.imagePreview}
                    />
                  )}
                </Box>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined" margin="normal">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    id="status"
                    name="status"
                    value={formik.values.status}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    label="Status"
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit" color="primary" variant="contained">
              {isEditMode ? "Update" : "Add"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

